// Single source of truth for which DashboardSetting id-array fields belong to the Task Filters
// dialog vs. the Location Filters dialog. Consumed by:
//   - OverviewFilterControls.tsx — the active-filter-count badge and "Clear" per dialog
//   - ViewsPanel.tsx — each saved view's "N filters · Tasks/Locations" summary
//   - LocationBreakdownPanel.tsx — its own task-filters-active check (a subset of TASK_FILTER_ID_FIELDS;
//     see that file for why `projectIds` is excluded there)
// Previously these were three independently hand-maintained copies of the same list, which drift
// silently if a filter field is ever added/removed without updating all three.
export const TASK_FILTER_ID_FIELDS = [
    'disciplineIds',
    'departmentIds',
    'phaseIds',
    'communityIds',
    'baselineIds',
    'projectIds',
] as const;

export const LOCATION_FILTER_ID_FIELDS = [
    'brandIds',
    'areaIds',
    'regionIds',
    'managementCompanyIds',
    'locationTypeIds',
    'continentIds',
    'locationIds',
    'tagIds',
] as const;
